import { resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_game_wrapper = _resolveComponent("game-wrapper")!

  return (_openBlock(), _createBlock(_component_game_wrapper, {
    title: "Test",
    name: "SpeedSolver",
    "is-game-over": _ctx.isGameOver,
    counter: _ctx.restartCounter,
    score: _ctx.score,
    scoreElements: _ctx.scoreElements,
    "action-buttons": _ctx.currentActionButtons,
    hasNoPreCountdown: true,
    onPrecountdownOver: _ctx.start,
    onRestart: _ctx.restart
  }, {
    top: _withCtx(() => []),
    default: _withCtx(() => []),
    bottom: _withCtx(() => []),
    _: 1
  }, 8, ["is-game-over", "counter", "score", "scoreElements", "action-buttons", "onPrecountdownOver", "onRestart"]))
}